import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  WarehouseIcon,


  WarehouseTree,
  ProductMasterWithReport,
  StockSummaryPivotReport,
  TransactionReport,
  WarehouseReports,
} from '../../assets';

const WarehousePage = () => {
  const productData = {
    productName: 'Warehouse',
    tagline: 'End-to-End Warehouse Management for 3PLs and Enterprise Logistics',
    metaDescription: 'WMS for 3PLs and logistics companies: ASN, GRN, putaway, picking, dispatch, cross-stuffing, stock reports, and invoicing in one warehouse management system.',
    description: 'Optimize every aspect of your warehouse operations with our comprehensive WMS. Manage ASN, GRN, Putaway, Picking, and Dispatch with precision. Features include Cross Stuffing, Internal Transfers, extensive Storage & Handling reports, and Invoicing.',
    icon: WarehouseIcon,
    features: [
      {
        title: 'Warehouse Location Tree',
        description: 'Visualize and manage your entire warehouse hierarchy with an interactive location tree.',
        image: WarehouseTree,
      },
      {
        title: 'Product Master with Reporting',
        description: 'Comprehensive product management integrated with detailed status reports.',
        image: ProductMasterWithReport,
      },
      {
        title: 'Stock Summary Pivot Report',
        description: 'Analyze inventory with dynamic pivot reports for stock levels and ageing.',
        image: StockSummaryPivotReport,
      },
      {
        title: 'Transaction Reports',
        description: 'Detailed logs of all inventory movements: Transfer, Delivery, Reciept etc.',
        image: TransactionReport,
      },
      {
        title: 'Comprehensive Warehouse Reports',
        description: 'Generate specific reports including Storage Summary, Stock Ledger, Stock Ageing, Handling Reports, and Warehouse Jobs for complete visibility.',
        image: WarehouseReports,
      },
    ],

  };

  return <ProductPageTemplate {...productData} />;
};

export default WarehousePage;
